import { render, staticRenderFns } from "./CircleQuestionConfig.vue?vue&type=template&id=020d4662"
import script from "./CircleQuestionConfig.vue?vue&type=script&lang=js"
export * from "./CircleQuestionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020d4662')) {
      api.createRecord('020d4662', component.options)
    } else {
      api.reload('020d4662', component.options)
    }
    module.hot.accept("./CircleQuestionConfig.vue?vue&type=template&id=020d4662", function () {
      api.rerender('020d4662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/CircleQuestionConfig.vue"
export default component.exports